import _ from "lodash";
import numeral from "numeral";
import { useEffect, useMemo, useState } from "react";
import { useBalanceStore } from "../../../_store/balanceStore";
import { cn } from "../../../utils/useFunctions";
import { options_debt_long, options_debt_short } from "../../balance/functions";
import {
  PdfBalanceHeaderItemDebtCard,
  PdfBalanceItemYearCard,
  PdfCard,
  PdfCardGray,
  PdfCardWhite,
} from "../component/pdf.c.card";
import PdfFooter from "../component/pdf.c.footer";
import PdfHeader from "../component/pdf.c.header";
import {
  PdfHeaderCardText,
  PdfHeaderText,
} from "../component/pdf.c.headerText";
import PdfLine from "../component/pdf.c.line";
import { calDebtLocalOption, getBalanceItems } from "../lib/pdf.lib";
import { STYLE_PAGE, STYLE_PDF_ITEM_TOTAL } from "../styles/pdf.style";
import {
  SumDebtPersonalValue,
  SumOtherDebtAmount,
} from "../../../functions/Balance/sumValueBalance";
import {
  sumCapitalInvest,
  sumDebtInvest,
} from "../../../functions/Balance/sumProperty";

const ItemYearCard = ({ item, className }) => {
  return (
    <div
      className={cn(
        " grid grid-cols-4 text-md font-bold text-mainblue px-[10px]",
        className
      )}
    >
      <div className="text-left col-span-2">{item?.label}</div>
      <div
        className={cn("text-center", {
          [STYLE_PDF_ITEM_TOTAL]: item?.label === "รวม",
        })}
      >
        {item?.amount_per_year}
      </div>
    </div>
  );
};

function PdfPageBalananceThree({ page }) {
  const balanceData = useBalanceStore((state) => state.balanceData);

  const [tempBalance, setTempBalance] = useState(balanceData);
  const [ReturnInsurance, setReturnInsurance] = useState([]);
  const [addInvest, setAddInvest] = useState(
    balanceData?.property_invest_list ? balanceData?.property_invest_list : []
  );

  useEffect(() => {
      if (tempBalance) {
        let tempInsuranceReturn = tempBalance?.expenses_fixed_list
          ?.filter(
            (item) => item.options_expenses_fixed === "expenses_insuarant_life"
          )
          ?.map((item) => item.expenses_insuarant_lifes)
          ?.flat();
  
        let tempBalanceData = {};
        //=============เงินลงทุนอื่น ๆ (สินทรัพย์ทางเลือก)=============//
  
        if (
          tempBalance?.property_invest_list
            ?.map((item) => item.options_property_invest_title)
            .includes("เงินลงทุนอื่น ๆ (สินทรัพย์ทางเลือก)") &&
          tempInsuranceReturn?.length === 0
        ) {
          // ถ้ามีหัวข้อนี้อยู่แล้ว
          let tempNameList = tempBalance?.property_invest_list
            .find(
              (item) =>
                item?.options_property_invest_title ===
                "เงินลงทุนอื่น ๆ (สินทรัพย์ทางเลือก)"
            )
            ?.invest_other_lists?.filter((item) => item !== null)
            ?.map((item) => item?.title);
  
          let tempInvestList = tempBalance?.property_invest_list?.map((item) => {
            if (item?.invest_other_lists) {
              let tempData = tempInsuranceReturn
                ?.map((item2) => {
                  if (!tempNameList?.includes(item2.title))
                    return {
                      amount: item2?.more_details?.policy_surrender_value,
                      created: item2.created,
                      reward_amount_per_year: item?.reward_amount_per_year || 1,
                      target_invest: {},
                      title: item2.title,
                      editable: false,
                    };
                })
                .filter((item) => item !== undefined);
              return {
                ...item,
                invest_other_lists: [...item.invest_other_lists, ...tempData],
              };
            }
            return item;
          });
  
          tempBalanceData = tempInvestList;
        } else {
          // ถ้ายังไม่มีหัวข้อนี้อยู่
          let tempInvestList = tempInsuranceReturn?.map((item) => {
            return {
              amount: item?.more_details?.policy_surrender_value,
              created: item.created,
              reward_amount_per_year: item?.reward_amount_per_year || 1,
              target_invest: item?.target_invest || {},
              title: item.title,
              editable: true,
            };
          });
  
          tempBalanceData = tempInvestList;
        }
        setReturnInsurance(tempBalanceData);
      }
      //==============================================//
    }, [balanceData]);

  const property =
    Number(balanceData?.sum_property_asset || 0) +
    SumDebtPersonalValue(balanceData) +
    sumCapitalInvest(addInvest, ReturnInsurance) +
    sumDebtInvest(balanceData) +
    Number(balanceData?.sum_property_private || 0) +
    SumOtherDebtAmount(balanceData) +
    Number(balanceData?.sum_property_intangible || 0);
  const debt = balanceData?.debt_propotion;
  const netWealth = balanceData?.net_wealth;

  const mergeOptions = useMemo(() => {
    return [
      {
        label: "หนี้สินระยะสั้น",
        key: "debt_short_list",
        key_option: "options_debt_short",
        options: options_debt_short,
        icon: "credit-card.svg",
      },
      {
        label: "หนี้สินระยะยาว",
        key: "debt_long_list",
        key_option: "options_debt_long",
        options: options_debt_long,
        icon: "mortgage-loan.svg",
      },
    ];
  }, []);

  const cloneMergeOptions = _.cloneDeep([...mergeOptions]);

  const propertyItems = useMemo(() => {
    let tempPropertyItems = getBalanceItems(
      balanceData,
      mergeOptions,
      calDebtLocalOption
    );
    return tempPropertyItems;
  }, [balanceData]);

  return (
    <div className={cn(STYLE_PAGE)}>
      <PdfHeader />
      <PdfLine />
      <PdfHeaderText title="งบดุล" icon="/images/balance.svg" />
      <PdfCard title={"หนี้สิน"}>
        {/* หนี้สิน */}
        <PdfCardWhite className={"flex flex-col"}>
          <PdfHeaderCardText
            title="รวมหนี้สินทั้งหมด"
            titleEnd={`${numeral(balanceData?.debt_propotion).format(
              "0,0"
            )} บาท`}
            icon=""
            classNameRoot="mt-2"
          />

          <PdfBalanceHeaderItemDebtCard title={""} />
          <PdfLine className={"my-2"} />

          <div className="mx-2 font-[500] text-[11px] my-1">หนี้สิน</div>

          {/* ITEMS */}
          {propertyItems?.map((propertyItem, index) => {
            return (
              <div key={index} className="flex flex-col mx-2">
                <div className="flex space-x-2 items-center">
                  <div>
                    <img
                      src={`/images/${propertyItem?.icon}`}
                      className="bg-cover"
                    />
                  </div>
                  <div className="text-[11px] font-[500]">
                    {propertyItem?.label}
                  </div>
                </div>

                <PdfCardGray className={"my-1 flex flex-col space-y-2"}>
                  {propertyItem.items?.map((item, index) => {
                    return (
                      <PdfBalanceItemYearCard
                        key={index}
                        item={item}
                        part={"PDF"}
                        classNamePDF={"font-[500]"}
                      />
                    );
                  })}
                </PdfCardGray>
              </div>
            );
          })}
          <ItemYearCard
            item={{
              label: "สินทรัพย์ - หนี้สิน = ",
              amount_per_year: "ความมั่งคั่งสุทธิ",
            }}
          />
          <ItemYearCard
            item={{
              label: `${numeral(property).format("0,0")} - ${numeral(debt).format(
                "0,0"
              )} =`,
              amount_per_year: numeral(property-debt).format("0,0"),
            }}
          />
        </PdfCardWhite>
      </PdfCard>
      <PdfFooter page={page} />
    </div>
  );
}

export default PdfPageBalananceThree;
